import { PLAN_COMPARISON_PAGE_PATH } from "./plan-comparison.js";

export const TECH_LOCAL_URL = "https://techlocal.co.za";
export const MIN_SITE_URL = "/";
export const MIN_FAQ_URL = "/#faq";
export const MIN_PLAN_BEHAVIOR_URL = PLAN_COMPARISON_PAGE_PATH;

export const MIN_LINKING_WELCOME_CONTENT = {
  title: "Give your WhatsApp an AI agent",
  body: "Min starts by turning WhatsApp voice notes into quick summaries right inside WhatsApp.",
  receivedLabel: "Voice notes you receive",
  receivedDetail: "Min sends the summary in a direct message.",
  sentLabel: "Voice notes you send",
  sentDetail: "Min sends the summary as a follow-up message.",
  securityTitle: "Your data stays secure.",
  securityDetail: "Min uses WhatsApp Web's secure end-to-end encryption flow.",
  creatorLabel: "Tech Local",
  creatorDetail: "a team building AI automation and custom software for consumers, small businesses, and enterprises.",
};

export const MIN_LINKING_NEXT_STEPS = [
  {
    title: "Link WhatsApp",
    detail: "Use the number on this phone first.",
  },
  {
    title: "Add email",
    detail: "Use it to sign in later and manage this number.",
  },
  {
    title: "Choose your defaults",
    detail: "Start with a free month of Fun, then upgrade only if you want more.",
  },
];

export const MIN_LINKING_TRUST_CHECKPOINT_CONTENT = {
  title: "WhatsApp may show a warning",
  body: "That warning is normal. Min links as a WhatsApp Web device so it can find your voice notes and send summaries back in WhatsApp.",
  points: [
    {
      text: "You can unlink Min anytime from WhatsApp > Linked Devices.",
    },
    {
      text: "We do not sell your data or mine your chats. Min acts only inside the settings you choose.",
    },
    {
      text: "Questions? Message Min Support anytime.",
    },
  ],
  ctaLabel: "I understand, show my code",
  secondaryCtaLabel: "Message Min Support",
};

export const MIN_LINKING_TRUST_PILLS = [
  "Built by Tech Local",
  "Uses WhatsApp Linked Devices",
  "Manage it later in Min",
];

export const MIN_TRUST_FAQS = [
  {
    q: "What do I get for free?",
    a: [
      "Everyone starts with one free month of Fun. ",
      "If someone sends you a Min link before you join, both of you get an extra month. ",
      { text: "See full plan behavior.", href: MIN_PLAN_BEHAVIOR_URL, planBehavior: true },
    ],
  },
  {
    q: "Why should I trust Min with my WhatsApp?",
    a: "Fair question. Min uses the same Linked Devices flow as WhatsApp Web. You can unlink Min from WhatsApp whenever you want.",
  },
  {
    q: "What is Min, and how do I use it?",
    a: "Min is an AI agent for WhatsApp. Today it starts with voice notes: link once, then Min sends summaries or transcripts inside WhatsApp when voice notes come in or go out. Broader monitoring and follow-through are coming with Agent.",
  },
  {
    q: "Why does Min need WhatsApp linking?",
    a: "Min uses linking to detect voice notes and send results back in WhatsApp. Without linking, it cannot do the live voice-note job.",
  },
  {
    q: "Who's behind Min?",
    a: [
      "Min is built by ",
      { text: "Tech Local", href: TECH_LOCAL_URL },
      ", a team building world-class AI automation and custom software for consumers, small businesses, and enterprises.",
    ],
  },
];
